import React from "react";


function PrivacyPolicy() {
  return (
    <div className="policy-page container">
      <h1 className="policy-title">Privacy Policy</h1>
      {/* <p className="last-updated">Last updated: September 11, 2025</p> */}

      <section>
        <h2>Introduction</h2>
        <p>
          We are committed to protecting your privacy. This Privacy Policy explains what
          information we collect, how we use it, how we safeguard it, and the choices you
          have regarding your personal information when you interact with our services.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <ul>
          <li>
            <strong>Personal Information:</strong> such as your name, email, phone number,
            address, and payment details when you place an order or contact us.
          </li>
          <li>
            <strong>Non-Personal Information:</strong> such as your IP address, browser type,
            device information, and browsing activity on our site.
          </li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Information</h2>
        <ul>
          <li>To process and fulfill your orders.</li>
          <li>To send order confirmations, updates, and customer service responses.</li>
          <li>To send you promotional offers and newsletters (only if you opt-in).</li>
          <li>To improve our website, products, and services.</li>
          <li>To protect against fraud and unauthorized transactions.</li>
        </ul>
      </section>

      <section>
        <h2>Cookies & Tracking</h2>
        <p>
          We use cookies and similar tracking technologies to enhance your experience,
          analyze site traffic, and deliver personalized content. You may disable cookies
          in your browser, but some features may not work properly.
        </p>
      </section>

      <section>
        <h2>Data Sharing</h2>
        <p>We do not sell or trade your personal information. We may share data only with:</p>
        <ul>
          <li>
            Trusted third-party service providers (e.g., payment gateways, shipping partners).
          </li>
          <li>Legal authorities when required by law.</li>
        </ul>
      </section>

      <section>
        <h2>Data Security</h2>
        <p>
          We are committed to safeguarding your information through secure technologies and
          processes. However, no method of electronic storage is 100% secure, and we cannot
          guarantee absolute security.
        </p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <ul>
          <li>Access and request a copy of the data we hold about you.</li>
          <li>Request correction or deletion of your personal data.</li>
          <li>Withdraw consent for marketing communications at any time.</li>
        </ul>
      </section>

      <section>
        <h2>Children’s Privacy</h2>
        <p>
          Our services are not directed at children under 13. We do not knowingly collect
          information from children. If we discover that a child has provided personal data,
          we will delete it promptly.
        </p>
      </section>
{/* 
      <section>
        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted
          on this page with an updated date.
        </p>
      </section> */}

      {/* <section>
        <h2>Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, you can reach us at:</p>
        <ul>
          <li>Email: info@yourwebsite.com</li>
          <li>Address: Your business address here</li>
        </ul>
      </section> */}
    </div>
  );
}

export default PrivacyPolicy;
